import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to Atlanta needed",
      "Ideal for Fort Benning soldiers and military families on PCS orders",
      "Perfect for Columbus State University students studying abroad",
      "Great for CSG airport international travelers",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Columbus post offices",
      "Good for planned international trips from CSG or ATL",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Muscogee County facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Columbus has no regional passport agency — closest is Atlanta, ~100 miles away",
      "NPIC appointment required before driving to Atlanta",
      "Life-or-death emergencies only with documentation",
      "Bereavement or medical crisis documentation required",
      "Expect to spend most of the day traveling and waiting",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ColumbusProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Columbus"
      headingExtra="GA"
      introText="Columbus and Fort Benning area travelers — active-duty soldiers and military families on PCS orders to Germany and Korea, Columbus State University students studying abroad, CSG airport international flyers, and Chattahoochee Valley residents planning overseas trips — have several options for getting an expedited passport. Here is how they compare, and why most west Georgia residents choose a registered U.S. Department of State passport courier for predictable, professional processing without the 100-mile drive to Atlanta."
      options={options}
      emergencyDescription="Columbus does not have its own regional passport agency. The closest agency is the Atlanta Passport Agency — approximately 100 miles northeast via I-185 and I-85, a 1.5–2 hour drive each way. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted. For Fort Benning soldiers on tight deployment timelines, this is rarely practical."
      disclaimerText="*Processing speed depends on eligibility and documentation. Columbus does not have a regional passport agency — the closest is Atlanta, roughly 100 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}